export default __webpack_public_path__ + "static/source-separation-systems-compost-a-pak-2a0cd83d6b57c7e48b1b386fc1a6be3c.jpg";